import React, { ReactNode } from 'react';
import type { AdminApiError } from '../errors';
import './mobileAdminComponents.css';

type Props = {
    loading?: boolean;
    error?: AdminApiError | null;
    empty?: boolean;
    emptyTitle?: string;
    emptyMessage?: string;
    onRetry?: () => void;
    children: ReactNode;
};

export function AsyncState({ loading, error, empty, emptyTitle = 'Nothing to show', emptyMessage, onRetry, children }: Props) {
    if (loading) return <div className="ma-state" role="status"><span className="ma-spinner" aria-hidden="true" />Loading…</div>;
    if (error) return (
        <div className={`ma-state ma-state--${error.kind === 'conflict' ? 'warning' : 'error'}`} role="alert">
            <strong>{error.kind === 'conflict' ? 'Information changed' : 'Unable to load'}</strong>
            <span>{error.message}</span>
            {error.requestId && <small>Request ID: {error.requestId}</small>}
            {onRetry && <button type="button" className="ma-button ma-button--secondary" onClick={onRetry}>Try again</button>}
        </div>
    );
    if (empty) return <div className="ma-state"><strong>{emptyTitle}</strong>{emptyMessage && <span>{emptyMessage}</span>}</div>;
    return <>{children}</>;
}
